module.exports = __webpack_public_path__ + "img/izeon.4f9f8af7.jpg";